import { setSelectedCompanyIdAtom } from "utils/jotaiStore";

export const getCompanyIdFromQueryAndClearStorage = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const companyIdFromQuery = urlParams.get('companyId');

  if (companyIdFromQuery) {
    localStorage.removeItem('company-id');
    setSelectedCompanyIdAtom(null);
  }

  return companyIdFromQuery;
};
